<div>
    <form [formGroup]="timesheetEditorForm">
        <div class="grid mt-2">
            <div class="col-12 lg:col-12 xl:lg:col-6 pb-3 pt-0 pl-0 pr-0 xl:pr-2">
                @if(reviewerName){
                <div class="w-full mb-3 flex align-items-center gap-2">
                    <p class="h6">{{'Candidate Name:' | sentenceCase}} </p>
                    <p class="m-0 mb-3"> {{reviewerName}}</p>
                </div>
                }
                @if(selectedRole && selectedRole.value){
                <div class="w-full mb-3">
                    <p-dropdown inputId="role" formControlName="selectedRole" [options]="roles" optionLabel="name"
                        placeholder="Select Role" />
                </div>
                }
                <div class="grid grid-nogutter align-items-stretch">
                    <div class="col-8">
                        <div class="grid grid-nogutter">
                            <div class="p-0 pt-2 col-12 xl:col-12 lg:col-12">
                                <span class="h6">{{'Start Time' | sentenceCase}}</span>
                            </div>
                            <div class="p-0 pt-2 col-12 xl:col-6 lg:col-6">

                                <p-floatLabel>
                                    <p-calendar formControlName="start_date" inputId="birth_date" placeholder="mm/dd/yy" />
                                </p-floatLabel>
                            </div>
                            <div class="p-0 mb-1 pt-2 col-12 xl:col-6 lg:col-6 pl-0 xl:pl-4 lg:pl-4">
                                <p-calendar inputId="calendar-timeonly" formControlName="start_time" [timeOnly]="true"
                                    hourFormat="12" styleClass="slider-style" />
                            </div>
                        </div>
                        @if(!timesheetEditorForm.get('isCurrentlyWorking')?.value){
                        <div class="grid grid-nogutter">
                            <div class="p-0 pt-3 col-12 xl:col-12 lg:col-12">
                                <span class="h6">{{"End Time" | sentenceCase}}</span>
                            </div>
                            <div class="p-0 pt-2 col-12 xl:col-6 lg:col-6">

                                <p-floatLabel>
                                    <p-calendar formControlName="end_date" inputId="birth_date" placeholder="mm/dd/yy" appendTo="body"/>
                                </p-floatLabel>
                            </div>
                            <div class="p-0 pt-2 mb-1 col-12 xl:col-6 lg:col-6 pl-0 xl:pl-4 lg:pl-4">
                                <p-calendar inputId="calendar-timeonly" formControlName="end_time" [timeOnly]="true"
                                    hourFormat="12" styleClass="slider-style" />
                            </div>
                        </div>
                        }
                    </div>
                    <div class="col-4 flex flex-column align-items-center justify-content-center border-1 border-round ml-3" style="max-width: calc(33.33% - 1rem); border-color: var(--primary-200) !important;">
                        <span class="text-xs text-500 mb-1">Duration</span>
                        <span class="font-semibold text-sm">{{ duration }}</span>
                    </div>
                </div>
                @if(from !== 'firm-manager') {
                <div>
                    <div class="switch-w-label pt-2 mt-2 flex gap-2">
                        <label for="stfProject" class="line-height-2">{{'Currently Working?' | sentenceCase}}</label>
                        <p-inputSwitch formControlName="isCurrentlyWorking" class="mpl-switch" inputId="stfProject"
                            ariaLabel="My Projects" />
                    </div>

                </div>
                }
                <div class="pt-3">
                    <p-floatLabel>
                        <textarea id="notes" formControlName="notes" rows="5" pInputTextarea></textarea>
                        <label for="notes">Notes</label>
                    </p-floatLabel>
                </div>

                <div class="flex justify-content-end mt-3">
                    <p-button (click)="cancel(false)" class="mr-2" label="cancel" [outlined]="true" [rounded]="true"
                        size="large" />
                    <p-button label="submit" size="large" [rounded]="true" (onClick)="onSubmit()" styleClass="freshgreen-background"/>
                </div>
            </div>
        </div>

    </form>
</div>